import { useState } from "react";
import ScreenplayVersionsModal from "@/components/ScreenplayVersionsModal";

/**
 * Botón compacto que abre el modal de Versiones del Guion.
 *
 * VIVE FUERA del editor protegido (`components/screenplay/**`).
 * Se monta como una franja superior justo encima del toolbar nativo del editor.
 * Cuando el usuario restaura una versión vieja del guion, llama a `onRestore`
 * pasando el nuevo `screenplay` completo (dict con elements/characters/etc.).
 *
 * NO toca la lógica interna del editor — sólo proporciona la entrada visual y
 * el flujo de selección/restauración.
 */
export default function ScreenplayVersionsButton({ projectId, currentScreenplay, onRestore, stats }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-3 border-b border-stone-300/70 bg-gradient-to-r from-[#F8F4EA] via-[#FBFAF4] to-[#F8F4EA] px-4 py-2"
           data-testid="screenplay-versions-bar">
        <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-stone-600">
          <span className="font-semibold text-[#941620]">⌖ Versiones del guion</span>
          <span className="text-stone-400">·</span>
          <span className="text-stone-500 normal-case tracking-normal">
            Snapshots independientes del texto. No tocan casting, dossier ni presupuesto.
          </span>
        </div>
        <button
          onClick={() => setOpen(true)}
          data-testid="screenplay-versions-open"
          className="rounded-full bg-[#2C2B29] px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.22em] text-white transition hover:bg-[#941620]"
        >
          ⌖ Abrir historial
        </button>
      </div>

      {open && (
        <ScreenplayVersionsModal
          projectId={projectId}
          currentScreenplay={currentScreenplay}
          stats={stats}
          onClose={() => setOpen(false)}
          onRestored={(newScreenplay) => {
            onRestore?.(newScreenplay);
            setOpen(false);
          }}
        />
      )}
    </>
  );
}
